import {
  slider1Movil,
  slider1Desktop,
  slider1DesktopMedium,
  slider1DesktopLarge,
  slider2Movil,
  slider2Desktop,
  slider2DesktopMedium,
  slider2DesktopLarge,
  slider3Movil,
  slider3Desktop,
  slider3DesktopMedium,
  slider3DesktopLarge,
} from "../assets";
import { TestimonialSlider } from "../components";
import { redirectURL } from "../constants/functions";

const actionRedirect = (history, type, option, position) => {
  redirectURL(history, type, {
    event: "button_click",
    payload: {
      section: "landing traspaso",
      sub_section: "banner",
      option: option,
      position_banner: position,
    },
  });
};

export const itemsConfig = [
  {
    top: "top92",
    title: "Eloy compró hoy su primer depa, con hasta el 25% de su fondo",
    background: "#E6FAFA",
    backgroundImages: {
      movil: slider1Movil,
      desktop: slider1Desktop,
      desktopMedium: slider1DesktopMedium,
      desktopLarge: slider1DesktopLarge,
    },
    buttons: [
      {
        text: "Cámbiate ya",
        action: (history) => {
          actionRedirect(history,"traspaso", "cambiate ya", "banner_1");
        },
      },
      {
        text: "Me está ayudando un asesor",
        action: (history) => {
          actionRedirect(history,"traspasoAsesor", "me estan asesorando", "banner_1");
        },
        variant: "secondary",
      },
    ],
  },
  {
    top: "top86",
    title: "Eloy aportó hoy a su fondo con Yape",
    backgroundImages: {
      movil: slider2Movil,
      desktop: slider2Desktop,
      desktopMedium: slider2DesktopMedium,
      desktopLarge: slider2DesktopLarge,
    },
    buttons: [
      {
        text: "Cámbiate ya",
        action: (history) => {
          actionRedirect(history, "traspaso", "cambiate ya", "banner_2");
        },
      },
      {
        text: "Me está ayudando un asesor",
        action: (history) => {
          actionRedirect(history, "traspasoAsesor", "me estan asesorando", "banner_2");
        },
        variant: "secondary",
      },
    ],
  },
  {
    top: "top66",
    title: "Eloy aseguró hoy el futuro de su familia con sus aportes en Prima AFP",
    backgroundImages: {
      movil: slider3Movil,
      desktop: slider3Desktop,
      desktopMedium: slider3DesktopMedium,
      desktopLarge: slider3DesktopLarge,
    },
    background: "#ffede6",    
    buttons: [
      {
        text: "Cámbiate ya",
        action: (history) => {
          actionRedirect(history, "traspaso", "cambiate ya", "banner_3");
        },
      },
      {
        text: "Me está ayudando un asesor",
        action: (history) => {
          actionRedirect(history, "traspasoAsesor", "me estan asesorando", "banner_3");
        },
        variant: "secondary",
      },
    ],
  },

];